(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-sector', {
            parent: 'entity',
            url: '/ss-sector',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSSectors'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-sector/s-s-sectors.html',
                    controller: 'SSSectorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-sector-detail', {
            parent: 'ss-sector',
            url: '/ss-sector/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSSector'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-sector/ss-sector-detail.html',
                    controller: 'SSSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSSector', function($stateParams, SSSector) {
                    return SSSector.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-sector',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-sector-detail.edit', {
            parent: 'ss-sector-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-dialog.html',
                    controller: 'SSSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSSector', function(SSSector) {
                            return SSSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-sector.new', {
            parent: 'ss-sector',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-dialog.html',
                    controller: 'SSSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-sector', null, { reload: 'ss-sector' });
                }, function() {
                    $state.go('ss-sector');
                });
            }]
        })
        .state('ss-sector.edit', {
            parent: 'ss-sector',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-dialog.html',
                    controller: 'SSSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSSector', function(SSSector) {
                            return SSSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-sector', null, { reload: 'ss-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-sector.delete', {
            parent: 'ss-sector',
            url: '/{id}/delete',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-sector/ss-sector-delete-dialog.html',
                    controller: 'SSSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSSector', function(SSSector) {
                            return SSSector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-sector', null, { reload: 'ss-sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
